module.exports = __webpack_public_path__ + "static/media/image-rock-1.png";